import {isEmptyValue} from '@/utils/commons'

const decimalNumberRegex = /^-?(?:\d+\.\d+|\d+|\.\d+)$/;
const specialCharRegex = /[^a-zA-Z0-9\s]/;

function getLabel(fieldName, rule) {
  return rule.excludeLabel ? '' : fieldName?.replace('*', '');
}

function validateRequired(val, label, rule) {
  if (rule.type === 'required' && val === '') {
    return `${label} ${rule.msg}`;
  }
}

function validateNumber(val, label, rule) {
  if (rule.type === 'number' && isNaN(val)) {
    return `${label} ${rule.msg}`;
  }
}

function validateMaxLength(val, label, rule) {
  if (rule.type === 'maxLength' && val && val.length > rule.limit) {
    return `${label} ${rule.msg}`;
  }
}

function validateMinLength(val, label, rule) {
  if (rule.type === 'minLength' && val.length < rule.limit) {
    return `${label} ${rule.msg}`;
  }
}

function validatePattern(val, label, rule) {
  if (rule.type === 'pattern' && !new RegExp(rule.regex).test(val)) {
    return `${label} ${rule.msg}`;
  }
}

function validateDecimal(val, label, rule) {
  if (rule.type === 'decimal' && !decimalNumberRegex.test(val)) {
    return `${label} ${rule.msg}`;
  }
}

function validateNoSpecialChar(val, label, rule) {
  if (rule.type === 'noSpecialChar' && specialCharRegex.test(val)) {
    return `${label} ${rule.msg}`;
  }
}

function validateMax(val, label, rule) {
  if (rule.type === 'max' && !isNaN(val) && Number(val) > rule.value) {
    return `${label} ${rule.msg}`;
  }
}

function validateCustom(val, rule) {
  if (rule.type === 'custom' && typeof rule.validate === 'function') {
    return rule.validate(val) || undefined;
  }
}

const useTextInputValidation = (fieldName, validationRules = []) => {
  const validate = value => {
    if (isEmptyValue(value)) {
      const requiredRule = validationRules.find(rule => rule.type === 'required');
      if (requiredRule) {
        return `${fieldName?.replace('*', '')} ${requiredRule.msg}`;
      }
      return null;
    }
    const val = String(value).trim();
    const rules = [...validationRules];
    let error;
    for (const rule of rules) {
      const label = getLabel(fieldName, rule);
      error =
        validateRequired(val, label, rule) ||
        validateNumber(val, label, rule) ||
        validateMaxLength(val, label, rule) ||
        validateMinLength(val, label, rule) ||
        validatePattern(val, label, rule) ||
        validateDecimal(val, label, rule) ||
        validateNoSpecialChar(val, label, rule) ||
        validateMax(val, label, rule) ||
        validateCustom(val, rule);
      if (error) break;
    }
    return error === undefined ? undefined : error;
  };

  const onChange = value => validate(value);

  return { onChange };
};


export default useTextInputValidation
